import styled from 'styled-components';

export const BottomRight = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 4px;
  height: 4px;

  background-color: var(--panel-bg-color);
  border: 1px solid #333;
  transform: translate(50%, 50%);

  cursor: se-resize;
`;
